export enum CardType {
    TASKS,
    PROCESSES,
    LAST_ACTIVITY,
}